/* Hero slider: crossfade, circular arrows, dots, optional autoplay.
   Pure vanilla, keyboard-accessible (buttons + roving aria-selected). */
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function HeroSlider(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    this.controls = document.querySelector('[data-slider-controls="' + root.id + '"]');
    if (!this.slides.length) return;

    this.dots = this.controls ? Array.prototype.slice.call(this.controls.querySelectorAll('[data-slider-dot]')) : [];
    this.prevBtn = this.controls ? this.controls.querySelector('[data-slider-prev]') : null;
    this.nextBtn = this.controls ? this.controls.querySelector('[data-slider-next]') : null;
    this.index = 0;
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    this.timer = null;

    this.bind();
    if (this.autoplay) this.play();
  }

  HeroSlider.prototype.bind = function () {
    var self = this;
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.go(i); self.restart(); });
    });
    if (this.autoplay) {
      this.root.addEventListener('mouseenter', function () { self.pause(); });
      this.root.addEventListener('mouseleave', function () { self.play(); });
      this.root.addEventListener('focusin', function () { self.pause(); });
      this.root.addEventListener('focusout', function () { self.play(); });
    }
  };

  HeroSlider.prototype.go = function (next) {
    var count = this.slides.length;
    var newIndex = (next + count) % count;
    if (newIndex === this.index) return;

    var current = this.slides[this.index];
    var incoming = this.slides[newIndex];

    current.classList.remove('is-active');
    current.setAttribute('aria-hidden', 'true');
    incoming.classList.add('is-active');
    incoming.removeAttribute('aria-hidden');

    if (this.dots[this.index]) {
      this.dots[this.index].classList.remove('is-active');
      this.dots[this.index].setAttribute('aria-selected', 'false');
    }
    if (this.dots[newIndex]) {
      this.dots[newIndex].classList.add('is-active');
      this.dots[newIndex].setAttribute('aria-selected', 'true');
    }

    this.index = newIndex;
  };

  HeroSlider.prototype.play = function () {
    if (!this.autoplay) return;
    var self = this;
    this.pause();
    this.timer = setInterval(function () { self.go(self.index + 1); }, this.autoplaySpeed);
  };

  HeroSlider.prototype.pause = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  HeroSlider.prototype.restart = function () {
    if (this.autoplay) this.play();
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-slider="hero"]').forEach(function (el) {
      new HeroSlider(el);
    });
  });
})();
